export default __webpack_public_path__ + "static/media/Brow_4_C1.a4d41fc3.svg";